import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PatientListService {
  init(ctx: any): void {
    ctx.getPatientList("");

    ctx.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === ctx.routerName) {
        ctx.sortColumn = res["name"];
        ctx.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        ctx.currentPage = 1;
        ctx.getPatientList(event);
      }
    });

    ctx.checkUrl();
  }

  checkUrl(ctx: any): void {
    const path = ctx.location.path().split("/");
    if (path.length === 3) {
      ctx.routerName = path[2];
    }
  }

  pageChanged(ctx: any, event: any): void {
    ctx.page = event.page;
    ctx.getPatientList(event);
  }

  onBlurMethod(ctx: any, val: any): void {
    if (val) {
      ctx.maxSizeItem = val;
    } else {
      ctx.maxSizeItem = 10;
    }
    ctx.currentPage = 1;
    ctx.getPatientList("");
  }

  onBlurSearchMethod(ctx: any): void {
    ctx.searchPatient = ctx.searchText;
    ctx.currentPage = 1;
    ctx.getPatientList("");
  }

  buildRequest(ctx: any, event: any, patientType: string): any {
    if (event) {
      return {
        pageNumber: event.page,
        pageRecord: ctx.maxSizeItem,
        sortColumn: ctx.sortColumn,
        sortType: ctx.orderColumn,
        patientType: patientType,
        search: ctx.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
      };
    } else {
      return {
        pageNumber: 1,
        pageRecord: ctx.maxSizeItem,
        sortColumn: ctx.sortColumn,
        sortType: ctx.orderColumn,
        patientType: patientType,
        search: ctx.searchPatient,
        tcId: localStorage.getItem("testCenterId"),
        startDate: "",
        endDate: "",
      };
    }
  }

  buildAddress(obj: any): string {
    let address = "";
    if (obj.patientAddressLine1) {
      address += obj.patientAddressLine1 + ", ";
    }
    if (obj.patientAddressLine2) {
      address += obj.patientAddressLine2 + ", ";
    }

    if (obj.patientCityName) {
      address += obj.patientCityName + ", ";
    }

    if (obj.patientStateName) {
      address += obj.patientStateName + ", ";
    }

    if (obj.patientCountryName) {
      address += obj.patientCountryName;
    }
    return address;
  }

  formatPhoneIn(phone: any, code: any): string {
    return code + " " + phone.replace(/^(\d{0,5})(\d{0,5})/, "$1-$2");
  }

  formatPhoneUs(phone: any, code: any): string {
    return (
      code + " " + phone.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3")
    );
  }

  loadPatients(ctx: any, data: any, mapFn: (obj: any) => any): void {
    ctx.appService.getpatientlistbytc(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            ctx.columnsData = [];
            ctx.columnsRes = res["entity"];
            ctx.columnsRes.forEach((obj) => {
              ctx.columnsData = ctx.columnsData.concat(mapFn(obj));
            });
            ctx.totalItems = res["count"];
          }
        } else {
          ctx.columnsData = [];
          ctx.totalItems = 0;
        }
      },
      (err) => {
        ctx.appService.sessionOut(err);
      }
    );
  }
}
